<script setup lang="ts" name="OrganisationVoyagesIndex">
import BaseCardNoData from '~/components/BaseCardNoData.vue';
import BasePage from '~/components/BasePage.vue';

import type { IOrganisation } from '~/types';

defineProps<{
  organisation: IOrganisation;
}>();
</script>

<template>
  <BasePage title="Voyages">
    <div class="col-span-full">
      <BaseCardNoData />
    </div>
  </BasePage>
</template>
